import React, { useState } from 'react';
import logo from './TBL Logo White.png';
import Quiz from './components/Quiz';
import './App.css';

function App() {
  const [showQuiz, setShowQuiz] = useState(false);

  const handleStartQuiz = () => {
    setShowQuiz(true);
  };

  const handleBackToHome = () => {
    setShowQuiz(false);
  };

  if (showQuiz) {
    return <Quiz onBackToHome={handleBackToHome} />;
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          THE FUTURE OF WINE IS HERE. DISCOVER YOUR PERFECT WINE MATCH.
        </p>
        <button 
          className="start-quiz-button"
          onClick={handleStartQuiz}
        >
          START THE QUIZ
        </button>
        <a
          className="App-link"
          href="https://thewineblendinglab.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          thewineblendinglab.com
        </a>
      </header>
    </div>
  );
}

export default App;
